import React from "react"
import { useSelector, useDispatch } from "react-redux"

import Images from "assets/images"
import {
    StoreType,
    SilDeviceNestedType,
    addModal,
    closeModal,
    setSilDeviceNestedNewList,
    setSilModelDevicesOnSelect,
    setSilModelDevicesModelTarget,
} from "client/store"
import { Logo } from "client/components"

import {
    ModelWrapper,
    BlockWrapper,
    Block,
    ChangeButton,
    AddButton,
    RemoveButton,
} from "client/pages/sil/modelStyled"

import ModelDevices from "client/pages/sil/modelDevices"
import { getSilDeviceTitle } from "client/pages/sil/formulas"

const Model = () => {
    const nestedDevices = useSelector((state: StoreType) => state.silDevice.nested.newDeviceList)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const addBlock = (index: number) => {
        const arr1 = nestedDevices.slice(0, index)
        const arr2 = nestedDevices.slice(index)
        arr1.push(null) // add empty block
        const newArr = arr1.concat(arr2)
        dispatch(setSilDeviceNestedNewList(newArr))
    }

    const removeBlock = (index: number) => {
        const arr1 = nestedDevices.slice(0, index)
        const arr2 = nestedDevices.slice(index + 1)
        const newArr = arr1.concat(arr2)
        dispatch(setSilDeviceNestedNewList(newArr))
    }

    const selectDevice = (device: SilDeviceNestedType, index: number) => {
        const arr1 = nestedDevices.slice(0, index)
        const arr2 = nestedDevices.slice(index + 1)
        arr1.push(device)
        const newArr = arr1.concat(arr2)

        dispatch(setSilDeviceNestedNewList(newArr))
        dispatch(closeModal())
    }

    const changeDevice = (index: number) => {
        dispatch(setSilModelDevicesModelTarget("subsystem"))
        dispatch(setSilModelDevicesOnSelect((device) => selectDevice(device as SilDeviceNestedType, index)))
        dispatch(addModal({
            key: "modelDevices",
            content: <ModelDevices />,
        }))
    }

    return (
        <ModelWrapper direction="row">
            <AddButton onClick={() => addBlock(0)} />

            {
                nestedDevices.map((nested, index) => ([
                    <BlockWrapper key="blockWrapper" type="subsystem">
                        <Block title={getSilDeviceTitle(nested as SilDeviceNestedType, moduleList, lang)}>
                            {
                                nested && (
                                    <Logo
                                        size={100}
                                        logo={
                                            nested.logo
                                            || (nested.qidProductId ? Images.qidProductLogo : Images.silDeviceLogo)
                                        }
                                    />
                                )
                            }
                            <ChangeButton onClick={() => changeDevice(index)}>
                                {nested ? lang.change : lang.add}
                            </ChangeButton>
                        </Block>
                        <RemoveButton onClick={() => removeBlock(index)} />
                    </BlockWrapper>,
                    <AddButton
                        key="addButton"
                        onClick={() => addBlock(index + 1)}
                    />,
                ]))
            }
        </ModelWrapper>
    )
}
export default Model
